


































































import Vue from 'vue'
import Cookies from 'js-cookie'
import * as types from '@/store/modules/play/types'
import settings from '@/settings'

export default Vue.extend({
  name: 'Config',

  computed: {
    /**
     * 音ズレ調整の値
     */
    audioLatencyAdjust: {
      get (): number {
        return this.$store.state[types.moduleName].audioLatencyAdjust
      },
      set (value: number) {
        this.$store.commit(`${types.moduleName}/${types.Mutation.AUDIO_LATENCY_ADJUST}`, value)
      },
    },
  },

  methods: {
    // /**
    //  * 音ズレの遅延調整
    //  * @parma audioLatencyAdjust
    //  */
    // setAudioLatencyAdjust (audioLatencyAdjust: number) {
    //   this.$store.commit(`${types.moduleName}/${types.Mutation.AUDIO_LATENCY_ADJUST}`, audioLatencyAdjust)
    // },

    /**
     * 閉じる
     */
    dismiss () {
      this.$emit('dismiss', true)
    },
  },

  watch: {
    audioLatencyAdjust (val: number) {
      if (val > 0) {
        // 調整をCookieに保存
        Cookies.set(settings.cookieName.audioLatencyAdjust, val.toString(), {
          expires: 30,
        })
      } else {
        // 調整なしならCookieから削除
        Cookies.remove(settings.cookieName.audioLatencyAdjust)
      }
    },
  },
})
